import { supabase } from '../../../lib/supabase';

// Limites defensivos caso o plano não exista no catálogo
const DEFAULT_LIMITS = {
    max_funnels: 2,
    max_contacts: 100,
    max_whatsapp: 1,
};

/**
 * Verifica os limites de uso da organização
 * Resiliente a organizações sem plano configurado
 */
export async function fetchOrganizationLimits(organizationId: string): Promise<{
    funnels: { current: number; max: number };
    contacts: { current: number; max: number };
    whatsapp: { current: number; max: number };
    users: { current: number; max: number };
}> {
    // Buscar plano atual
    const { data: org, error: orgError } = await supabase
        .from('organizations')
        .select('plan, quantity')
        .eq('id', organizationId)
        .single();

    if (orgError || !org) {
        throw new Error('Organização não encontrada');
    }

    // Buscar limites do plano (fallback defensivo caso o catálogo esteja inconsistente)
    let planLimits = DEFAULT_LIMITS;

    const { data: plan, error: planError } = await supabase
        .from('subscription_plans')
        .select('max_funnels, max_contacts, max_whatsapp')
        .eq('id', org.plan)
        .maybeSingle();

    if (!planError && plan) {
        planLimits = plan;
    } else {
        console.warn(`[subscription.limits] Plano '${org.plan}' não encontrado ou erro, usando limites padrão`);
    }

    // Contar recursos atuais
    const [funnelsResult, contactsResult, whatsappResult, membersResult] = await Promise.all([
        supabase.from('funnels').select('id', { count: 'exact', head: true }).eq('organization_id', organizationId),
        supabase.from('contacts').select('id', { count: 'exact', head: true }).eq('organization_id', organizationId),
        supabase.from('whatsapp_instances').select('id', { count: 'exact', head: true }).eq('organization_id', organizationId),
        supabase.from('organization_members').select('id', { count: 'exact', head: true }).eq('organization_id', organizationId),
    ]);

    return {
        funnels: {
            current: funnelsResult.count || 0,
            max: planLimits.max_funnels
        },
        contacts: {
            current: contactsResult.count || 0,
            max: planLimits.max_contacts
        },
        whatsapp: {
            current: whatsappResult.count || 0,
            max: planLimits.max_whatsapp
        },
        users: {
            current: membersResult.count || 0,
            max: org.quantity || 1
        },
    };
}
